import { computed, unref } from "vue";
import { useBadgeHoldersViewState } from "./useBadgeHoldersViewState";

export function useTableConfig(filterLevels = [], onRemoveBadge = null, badgeLevelCounts = {}) {
  const viewState = useBadgeHoldersViewState();
  
  const levelCounter = computed(() => {
    // Use unref to access the value whether it's a ref, reactive object, or plain object
    const counts = unref(badgeLevelCounts);
    const result = {
      apprentice: counts.apprentice ?? 0,
      professional: counts.professional ?? 0,
      coach: counts.coach ?? 0,
      master: counts.master ?? 0,
    };
    return result;
  });

  const tableParams = computed(() => {
    // Unwrap levelCounter to get the actual value and maintain reactivity
    const levelCounterValue = levelCounter.value;
    
    return {
      headers: [
        {
          text: "Badge Holder",
          sortable: false,
          value: "name",
        },
        {
          text: "Badge Level",
          sortable: false,
          value: "level",
        },
        {
          text: "Issued By/On",
          sortable: false,
          value: "assignedBy",
          width: "150px",
        },
        {
          text: "Removed By/On",
          sortable: false,
          value: "removedBy",
          width: "150px",
        },
        {
          text: "Reason",
          sortable: false,
          value: "reason",
        },
      ],
      columns: [
        {
          field: "",
          component: "UserCard",
          props: (item) => {
            return {
              class: "my-4",
              user: item.user,
              employee: item.employee,
              userStatus: item.userStatus,
              employeeStatus: item.employeeStatus,
              showStatusBadge: false,
              accountHover: item.accountHover || false,
            };
          },
          events: (item) => ({
            // Add events if needed
          }),
        },
        {
          field: "",
          component: "ReadinessBadge",
          props: (item) => {
            return {
              class: "my-4",
              level: item.badge?.level || "Novice",
              dot: item.badge?.dot || "No Dot",
              view: item.badge?.view || "ReadOnly",
              expiration_date: item.badge?.expiration_date || null,
              has_expiration_if_obsolete: item.badge?.has_expiration_if_obsolete || false,
              plain: false,
              mini: false,
              upgraded: item.badge?.upgraded || false,
              upgradedVariantIcon: item.badge?.upgradedVariantIcon || null,
              unread: item.badge?.unread || 0,
              hideChatterIcon: true,
            };
          },
          events: (item) => ({
            removeBadge: () => {
              if (onRemoveBadge) {
                onRemoveBadge(item);
              }
            },
          }),
        },
        {
          field: "",
          component: "Stamp",
          props: (item) => {
            return {
              class: "my-4",
              name: item.assignedBy?.name || "",
              avatar: item.assignedBy?.picture || "",
              date: item.assignedBy?.displayDate || null,
              show_time: true,
            };
          },
          events: (item) => ({
            // Add events if needed
          }),
        },
        {
          field: "",
          component: "Stamp2",
          props: (item) => {
            return {
              class: "my-4",
              name: item.removedBy?.name || "",
              avatar: item.removedBy?.picture || "",
              date: item.removedBy?.displayDate || null,
              show_time: true,
            };
          },
          events: (item) => ({
            // Add events if needed
          }),
        },
        {
          field: "reason",
          component: null,
          props: (item) => {
            return {
              class: "my-4",
            };
          },
        },
      ],
      filters: {
        values: viewState.state.filters.values,
        searchText: viewState.state.filters.searchText,
        searchGhostText: viewState.state.filters.searchGhostText,
      },
      hideTopSection: true,
      hideSearchAndFilters: false,
      hideActiveNo: true,
      showActionButton: false,
      activeRecords: {
        field: "status",
        value: "active",
      },
      defaultOrderingField: "issued_to__first_name",
      activeRecordsCount: 0,
      actionLabel: "Issue Badge",
      hideGridView: true,
      title: "",
      orderingStorageKey: "badgeHolders.ordering",
      showLevelCounter: true,
      levelCounter: levelCounterValue,
      filterLevels: filterLevels,
      customEmptyTitle: "No Badge Holders found",
      customEmptyDescription: "With the current search/filter, we could not find any Badge Holder",
      getRowStyle: (item) => ({
        backgroundColor: "#FFFFFF",
      }),
    };
  });

  return {
    tableParams,
  };
}


